// This file controls whether to use the new printables logic (with packaging tax percentages)
// or the old printables logic (without packaging tax percentages).
//
// USE_NEW_PRINT_LOGIC: 
//   - If true, records created on or after CUTOFF_DATE will use the new logic.
//   - If false, ALL records will use the old logic regardless of date.
//
// CUTOFF_DATE:
//   - The date after which new printables logic applies.

export const USE_NEW_PRINT_LOGIC = true;
export const CUTOFF_DATE = new Date('2026-06-12T00:00:00.000Z');

export function shouldUseNewPrintLogic(createdAt) {
  if (!USE_NEW_PRINT_LOGIC) return false;
  if (!createdAt) return true;
  const recordDate = new Date(createdAt);
  return recordDate >= CUTOFF_DATE;
}
